import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { FileKind } from "../../../define/FileKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { backpackUpdataDialog, backpackUseRuleI } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import backpackOpenBase from "../backpackOpenBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class AcquireSepecialAwardLayer extends backpackOpenBase {

    @property({type:cc.Node,displayName:"普通的按钮layout"})
    normalBtnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"top节点"})
    topNode:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    explainLb:cc.Label = null;

    @property({type:cc.Label,displayName:"名字文本"})
    nameLb:cc.Label = null;

    @property({type:cc.Label,displayName:"品级文本"})
    levelLb:cc.Label = null;

    @property({type:cc.Node,displayName:"光效节点"})
    lightNode:cc.Node = null;

    @property(cc.Sprite)
    sprGoods: cc.Sprite = null;

    private itemConfig: NormalBackpackI = null;
    private useRule: backpackUseRuleI = null;

    private goodsId: number = 0;

    onLoad(){

    }

    start(){
        let tween = cc.tween(this.lightNode).by(3,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        })
        cc.tween(this.lightNode).repeatForever(tween).start();

        let itemConfig = this.itemConfig = backPackEventMap()[this.goodsId];
        this.nameLb.string = itemConfig.name;
        this.setExplain(itemConfig.details);
        this.loadGoodsIcon(itemConfig.spPath);
        this.refreshPrice(itemConfig.sellPrice);
    }

    onBackPackOpenPrefab(useRule: backpackUseRuleI){
        // this.itemConfig = backPackEventMap()[useRule.backId];
        this.useRule = useRule;
        
        let backUseOrGiveParam = this.useRule.backUseOrGiveParam;
        let goods = backUseOrGiveParam['goods'] as string[];
        if (!goods || goods.length <= 0) {
            console.error(`未找到数据`, backUseOrGiveParam);
            return;
        }
        
        super.onBackPackOpenPrefab(useRule);
        let randomNum = data_control.randomNum(0, 1);
        let randomTotal = 0;
        for (let o of goods) {
            let splits = o.split(FileKind.ResParseType.SUB_ITEM2).map(Number);
            randomTotal += splits[1];
            if (randomNum <= randomTotal) {
                this.goodsId = splits[0];
                NormalGameManager._instance.onPushGoods(this.goodsId, 1);
                break;
            }
        }
    }

    async loadGoodsIcon(spPath: string) {
        if(spPath && spPath != ""){
            let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
            bundle.load(
                `backpackAssets/objSp/${spPath}`
                , cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log("加载背包图片失败",err);
                    }else{
                        if(this.sprGoods && this.sprGoods.isValid){
                            this.sprGoods.spriteFrame = spr;
                        }
                    }
                }
            );
        }
    }

    refreshPrice(price: number) {
        let btn:cc.Node = this.normalBtnLayout.children[1];
        let label = btn.getChildByName("layout").getChildByName("lb_money").getComponent(cc.Label);
        label.string = data_control.getNumberFormat(price);
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
        O1HD.emit(backpackUpdataDialog, null, null, true);
    }

    onBtnPushBackPack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
        O1HD.emit(backpackUpdataDialog, null, null, true);
    }

    onBtnOpenBlind(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        NormalGameManager._instance.onOutGoods(this.itemConfig.id, 1);
        let targetNode:cc.Node = e.target;
        let coin = this.itemConfig.sellPrice;
        O1HD.getServices().userSrv.setCoins(coin,true,targetNode);
        this.closeThis();
    }

    async setExplain(str:string){
        this.explainLb.string = "";
        return new Promise<void>(async resolve=>{
            for(let i = 0;i<str.length;i++){
                this.explainLb.string += str[i];
                await new Promise<void>(resolve=>{
                    this.scheduleOnce(resolve,0.02);
                });
            }
            resolve();
        });
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }
}
